/* eslint-disable @next/next/no-sync-scripts */
import { useRouter } from 'next/compat/router';
import React from 'react';

import OptimizelyScripts from '../../components/OptimizelyScripts';
import GlobalStyle from '../GlobalStyle';
import LayoutHead from '../LayoutHead';
import { PreviewModeAlert } from '../PreviewModeAlert';
import { Subnav } from '../Subnav';

interface LayoutProps {
    head: string;
    menu?: unknown;
    preview?: boolean;
    children: React.ReactNode;
    NavComponent?: React.ComponentType<unknown>;
}

const Layout: React.FC<LayoutProps> = ({
    head,
    menu,
    preview,
    children,
    NavComponent = Subnav,
}) => {
    const router = useRouter();
    return (
        <React.Fragment>
            <LayoutHead head={head} preview={preview} />
            <OptimizelyScripts />
            <GlobalStyle />
            <NavComponent router={router} menu={menu} head={head} />
            {preview && <PreviewModeAlert />}
            {children}
        </React.Fragment>
    );
};

export default Layout;
